import styled from 'styled-components';
import colors from '../../../config/colors';

const ButtonOptionsInline = styled.div`
  display: flex;
  margin: 20px 0;

  @media (max-width: 576px) {
    flex-wrap: wrap;
    margin: 10px 0;
  }

  button, a, > span {
    margin-right: 12px;
    padding: 9px 15px;
    display: flex;
    align-items: center;
    line-height: 1;

    @media (max-width: 576px) {
      margin: 0 5px 10px 5px;
    }

    img, svg {
      margin-right: 10px;
      fill: ${colors.WHITE_COLOR};
      align-self: center;
      flex-shrink: 0;

      @media (max-width: 576px) {
        margin-right: 5px;
      }
    }

    &:last-child {
      margin-right: 0;
    }
    
  }
`;

export default ButtonOptionsInline;
